"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var FontAwesome5_1 = __importDefault(require("react-native-vector-icons/FontAwesome5"));

var button_1 = require("../../../../components/pricing/buttons/button/button");

var page_connected_1 = require("../../../../components/pricing/layout/page/page.connected");

var pricing_table_1 = require("../../../../components/pricing/layout/pricing-table/pricing-table");

var pharmacy_management_page_content_1 = require("../../../../theming/pricing-system/pharmacy-management-page.content");

var pharmacy_edit_dialog_1 = require("../../dialogs/pharmacy-edit-dialog/pharmacy-edit-dialog");

var select_group_message_1 = require("../../messages/select-group-message/select-group-message");

var pricing_experience_navigator_screen_names_1 = require("../../pricing-experience-navigator/pricing-experience-navigator.screen-names");

var tableColumns = pharmacy_management_page_content_1.PharmacyManagementPageContent.tableColumns;
var headerData = [tableColumns.ncpdp.text, tableColumns.name.text, tableColumns.addr1.text, tableColumns.addr2.text, tableColumns.city.text, tableColumns.state.text, tableColumns.actions.text];
var columnWidths = [tableColumns.ncpdp.width, tableColumns.name.width, tableColumns.addr1.width, tableColumns.addr2.width, tableColumns.city.width, tableColumns.state.width, tableColumns.actions.width];
var tableViewStyle = {
  marginTop: '1rem',
  width: '100%'
};
var tableTextStyle = {
  fontSize: '1rem'
};

var PharmacyManagementPage = function (_super) {
  __extends(PharmacyManagementPage, _super);

  function PharmacyManagementPage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {};

    _this.onPharmacyEditDialogClose = function () {
      _this.setState({
        showPharmacyEditDialog: false
      });

      var passwordClear = _this.props.passwordClear;

      if (passwordClear) {
        passwordClear();
      }
    };

    return _this;
  }

  PharmacyManagementPage.prototype.componentDidMount = function () {
    this.refreshPharmaciesIfRequired();
  };

  PharmacyManagementPage.prototype.componentDidUpdate = function () {
    this.refreshPharmaciesIfRequired();
  };

  PharmacyManagementPage.prototype.render = function () {
    return react_1.default.createElement(page_connected_1.PageConnected, {
      title: pharmacy_management_page_content_1.PharmacyManagementPageContent.title,
      selectedTabValue: pricing_experience_navigator_screen_names_1.NavigationScreenNames.pharmacyManagementPage,
      showPharmacyGroup: true,
      isAdmin: true
    }, this.renderPageContent());
  };

  PharmacyManagementPage.prototype.renderPageContent = function () {
    if (!this.props.currentGroup) {
      return react_1.default.createElement(select_group_message_1.SelectGroupMessage, null);
    }

    return react_1.default.createElement(react_1.default.Fragment, null, this.renderPharmacyEditDialog(), this.renderPricingTable());
  };

  PharmacyManagementPage.prototype.renderPricingTable = function () {
    var _this = this;

    var pharmacies = this.props.pharmacies || [];
    var bodyData = pharmacies.map(function (pharmacy) {
      var address = pharmacy.address;
      var rowData = [pharmacy.ncpdp, pharmacy.name, address.lineOne, address.lineTwo || '', address.city, address.state, _this.renderRowActions(pharmacy.ncpdp, pharmacy.name)];
      return rowData;
    });
    return react_1.default.createElement(pricing_table_1.PricingTable, {
      caption: this.tableCaption,
      headerData: headerData,
      bodyData: bodyData,
      emptyTableText: this.emptyTableText,
      style: tableViewStyle,
      textStyle: tableTextStyle,
      columnWidths: columnWidths,
      footer: pharmacy_management_page_content_1.PharmacyManagementPageContent.tableFooter(pharmacies.length)
    });
  };

  PharmacyManagementPage.prototype.renderRowActions = function (ncpdp, name) {
    var _this = this;

    var onEditClick = function onEditClick() {
      _this.setState({
        currentPharmacyNcpdp: ncpdp,
        showPharmacyEditDialog: true
      });
    };

    var viewStyle = {
      marginBottom: '.1em',
      marginTop: '.1em',
      minWidth: 'auto',
      paddingBottom: '.2em',
      paddingTop: '.2em'
    };
    var textStyle = {
      fontSize: '1rem'
    };
    var buttonLabel = react_1.default.createElement(FontAwesome5_1.default, {
      name: "pencil-alt",
      size: 16
    });
    var iconText = pharmacy_management_page_content_1.PharmacyManagementPageContent.pharmacyEditIconText(name);
    return react_1.default.createElement(button_1.Button, {
      iconText: iconText,
      label: buttonLabel,
      onPress: onEditClick,
      textStyle: textStyle,
      viewStyle: viewStyle,
      type: "icon"
    });
  };

  PharmacyManagementPage.prototype.renderPharmacyEditDialog = function () {
    if (!this.state.showPharmacyEditDialog) {
      return null;
    }

    var widthInRem = 40;
    var viewStyle = {
      alignSelf: 'center',
      maxWidth: widthInRem + "rem",
      position: 'absolute',
      top: '20%'
    };
    var pharmacyNcpdp = this.state.currentPharmacyNcpdp || '';
    var pharmacy = this.getPharmacy(pharmacyNcpdp);
    var name = pharmacy ? pharmacy.name : '';
    var emailAddress = pharmacy ? pharmacy.emailAddress : '';
    var pharmacyUserOid = pharmacy ? pharmacy.userOid : '';
    return react_1.default.createElement(pharmacy_edit_dialog_1.PharmacyEditDialog, {
      viewStyle: viewStyle,
      onClose: this.onPharmacyEditDialogClose,
      onPasswordGenerate: this.props.passwordGenerate,
      pharmacyNcpdp: pharmacyNcpdp,
      pharmacyName: name,
      pharmacyUserOid: pharmacyUserOid,
      pharmacyPassword: this.props.pharmacyPassword,
      emailAddress: emailAddress
    });
  };

  PharmacyManagementPage.prototype.getPharmacy = function (ncpdp) {
    var pharmacies = this.props.pharmacies || [];
    return pharmacies.find(function (pharmacy) {
      return pharmacy.ncpdp === ncpdp;
    });
  };

  PharmacyManagementPage.prototype.refreshPharmaciesIfRequired = function () {
    var getPharmacies = this.props.pharmaciesGet;

    if (getPharmacies && this.props.doPharmaciesRefresh) {
      getPharmacies(this.currentGroupOid);
    }
  };

  Object.defineProperty(PharmacyManagementPage.prototype, "tableCaption", {
    get: function get() {
      return pharmacy_management_page_content_1.PharmacyManagementPageContent.tableCaption(this.currentGroupName);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(PharmacyManagementPage.prototype, "emptyTableText", {
    get: function get() {
      return pharmacy_management_page_content_1.PharmacyManagementPageContent.emptyTableText(this.currentGroupName);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(PharmacyManagementPage.prototype, "currentGroupOid", {
    get: function get() {
      return this.props.currentGroup ? this.props.currentGroup.groupOid : undefined;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(PharmacyManagementPage.prototype, "currentGroupName", {
    get: function get() {
      return this.props.currentGroup ? this.props.currentGroup.name : '';
    },
    enumerable: true,
    configurable: true
  });
  return PharmacyManagementPage;
}(react_1.default.Component);

exports.PharmacyManagementPage = PharmacyManagementPage;